(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2151],{

/***/ 45:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mission",
      function () {
        return __webpack_require__(59768);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 59768:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ mission; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js
var Box = __webpack_require__(99226);
// EXTERNAL MODULE: ./src/v2/components/layout/website/landing/SupportedBySlide.tsx
var SupportedBySlide = __webpack_require__(83034);
// EXTERNAL MODULE: ./src/v2/components/layout/website/LandingEngagement.tsx
var LandingEngagement = __webpack_require__(14825);
// EXTERNAL MODULE: ./src/v2/components/layout/website/LandingFooter.tsx
var LandingFooter = __webpack_require__(28424);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./src/v2/components/ui/images/index.tsx + 1 modules
var ui_images = __webpack_require__(24639);
// EXTERNAL MODULE: ./src/components/theme/styles/colors.tsx
var colors = __webpack_require__(16381);
// EXTERNAL MODULE: ./src/v2/components/layout/website/SlideWrapper.tsx
var SlideWrapper = __webpack_require__(47697);
;// CONCATENATED MODULE: ./src/v2/components/layout/website/mission/MissionLandingSlide.tsx
/* eslint-disable react/no-unknown-property */ 





function MissionLandingSlide() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SlideWrapper/* default */.Z, {
        sx: {
            justifyContent: "center",
            overflow: "hidden",
            pt: 32
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
            container: true,
            direction: {
                xs: "column-reverse",
                sm: "row"
            },
            justifyContent: "start",
            textAlign: "left",
            spacing: 1,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                    item: true,
                    xs: 12,
                    sm: 7,
                    pr: 2,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "h2",
                            mt: 4,
                            children: "Vesta’s Mission"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "body1",
                            mt: 4,
                            mb: 8,
                            color: colors/* primaryColors.400 */.w2[400],
                            children: "Vesta aims to drive lasting impact and create long-term value through financial innovation that addresses significant problems."
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    item: true,
                    textAlign: "center",
                    xs: 12,
                    sm: 5,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_images/* Wormhole */.Df, {})
                })
            ]
        })
    });
}
/* harmony default export */ var mission_MissionLandingSlide = (MissionLandingSlide);

// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js
var Stack = __webpack_require__(26447);
;// CONCATENATED MODULE: ./src/v2/components/layout/website/mission/SolveProblemsSlide.tsx
/* eslint-disable react/no-unknown-property */ 





var SolvePanel = function(param) {
    var text1 = param.text1, text2 = param.text2, reverse = param.reverse;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        container: true,
        direction: {
            xs: "column-reverse",
            sm: reverse ? "row-reverse" : "row"
        },
        justifyContent: "center",
        alignItems: "center",
        spacing: 1,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                xs: 6,
                pr: 2,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    sx: {
                        textAlign: "left",
                        pt: {
                            xs: 8,
                            sm: 0
                        }
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "h5",
                            color: colors/* primaryColors.100 */.w2[100],
                            children: text1
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            mt: 2,
                            variant: "body1",
                            color: colors/* primaryColors.400 */.w2[400],
                            children: text2
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                xs: 6,
                textAlign: "center",
                mt: {
                    xs: 4,
                    sm: 0
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_images/* Wormhole */.Df, {})
            })
        ]
    });
};
function SolveProblemsSlide() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SlideWrapper/* default */.Z, {
        sx: {
            justifyContent: "center",
            overflow: "hidden"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
            spacing: 8,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "h4",
                    mt: 4,
                    children: "Solving significant financial problems through innovative solutions."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "body1",
                    mt: 4,
                    mb: 8,
                    color: colors/* primaryColors.400 */.w2[400],
                    children: "Vesta aims to drive lasting impact and create long-term value through financial innovation that addresses significant problems."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SolvePanel, {
                    reverse: true,
                    text1: "Continuously striving for breakthrough innovation",
                    text2: "Innovation is at the core of Vesta! An inclusive financial future will come from cutting-edge solutions."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SolvePanel, {
                    text1: "Empowering people through clear financial demystification",
                    text2: "Financial innovations should be accessible to everyone. Large efforts are put in presenting complex financial concepts in simple and easy-to-understand ways."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SolvePanel, {
                    reverse: true,
                    text1: "Pushing the limits while promoting a positive and healthy culture",
                    text2: "At Vesta, we believe that a positive environment is the key to promote creativity and experimentation."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SolvePanel, {
                    text1: "Elevating the standard of excellence",
                    text2: "The best is not enough for our users. We are dedicated to meeting the highest expectations through exceptional standards."
                })
            ]
        })
    });
}
/* harmony default export */ var mission_SolveProblemsSlide = (SolveProblemsSlide);

// EXTERNAL MODULE: ./src/v2/components/ui/containers/fade/index.tsx
var fade = __webpack_require__(41394);
;// CONCATENATED MODULE: ./src/pages/mission.tsx









var MissionPage = function() {
    var ref = (0,react.useState)(false), visible = ref[0], setVisible = ref[1];
    (0,react.useEffect)(function() {
        setTimeout(function() {
            setVisible(true);
        }, 1);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(fade/* FadeContainer */.B, {
                visible: visible ? 1 : 0,
                time: 0.5,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(mission_MissionLandingSlide, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(mission_SolveProblemsSlide, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SupportedBySlide/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingEngagement/* default */.Z, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingFooter/* default */.Z, {})
        ]
    });
};
/* harmony default export */ var mission = (MissionPage);


/***/ }),

/***/ 83034:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26447);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15861);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(86886);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(83321);
/* harmony import */ var phosphor_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(27842);
/* harmony import */ var _components_shared_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67113);
/* harmony import */ var _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16381);
/* harmony import */ var _SlideWrapper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47697);







var VIP_SHILL_LIST = [
    {
        person: "TETRANODE",
        href: ""
    },
    {
        person: "DCFGOD",
        href: ""
    },
    {
        person: "FISKANTES",
        href: ""
    },
    {
        person: "NOT3LAU CAPITAL",
        href: ""
    },
    {
        person: "SAM KAZEMIAN@FRAX",
        href: ""
    },
    {
        person: "OXMONS@SUDOSWAP",
        href: ""
    },
    {
        person: "MARIANO CONTI",
        href: ""
    },
    {
        person: "FISHERS CAPITAL",
        href: ""
    },
    {
        person: "ANGELDAO",
        href: ""
    }, 
];
var SupportedBySlide = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_SlideWrapper__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                spacing: 8,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        variant: "h4",
                        color: _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_3__/* .primaryColors[50] */ .w2[50],
                        children: "Supported by the best"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        variant: "body1",
                        color: _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_3__/* .primaryColors[400] */ .w2[400],
                        children: "Not to namedrop but, some heavy players are around"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                container: true,
                direction: "row",
                justifyContent: "space-between",
                spacing: 4,
                mt: 8,
                children: VIP_SHILL_LIST.map(function(param) {
                    var person = param.person, href = param.href;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                        item: true,
                        xs: 12,
                        sm: 6,
                        md: 4,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_link__WEBPACK_IMPORTED_MODULE_2__/* .NormalLink */ .Yk, {
                            sx: {
                                textDecoration: "none"
                            },
                            href: href,
                            target: "_blank",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                variant: "primary",
                                fullWidth: true,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                    direction: "row",
                                    spacing: 2,
                                    alignItems: "center",
                                    textAlign: "start",
                                    width: "100%",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(phosphor_react__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                            size: 16,
                                            color: _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_3__/* .primaryColors[400] */ .w2[400]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                            variant: "label2",
                                            sx: {
                                                background: "linear-gradient(278.18deg, rgba(124, 79, 219, 0.8) -7.61%, rgba(0, 251, 234, 0.5) 39.1%, #B5EDFF 83.03%), #FFFFFF",
                                                backgroundClip: "text",
                                                WebkitTextFillColor: "transparent"
                                            },
                                            children: person
                                        })
                                    ]
                                })
                            })
                        })
                    }, person);
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                variant: "body1",
                color: _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_3__/* .primaryColors[400] */ .w2[400],
                mt: 8,
                children: "And more..."
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SupportedBySlide);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6731,9774,2888,179], function() { return __webpack_exec__(45); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);